import PropTypes from "prop-types";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import useStyle from "./style";
import { useState } from "react";

import FotoVitrine from "../../Assets/img/shelf/Foto.png";
import Details from "../../Assets/img/shelf/top.png";
import Bradcrumb from "../../Assets/img/shelf/bradcrumb.png";
import Preview from "../../Assets/img/shelf/preview.png";
import FotoPDP from "../../Assets/img/shelf/Foto-pdp.png";
import Info from "../../Assets/img/shelf/info.png";
import Review from "../../Assets/img/shelf/review.png";
import Caracteristics from "../../Assets/img/shelf/Características.png";
import Cart from "../../Assets/img/shelf/Carrinho_Frete.png";
import { apiLabsV2 } from "../../Services/api";

import { toast } from "react-toastify";
import { FIXED_BACKGROUND_FLAG, FIXED_FONT_COLOR_FLAG } from ".";

export const DetailsSeal = ({ seal, setSeal, isEdit }) => {
  const style = useStyle();

  const [errors, setErrors] = useState({});

  const [open, setOpen] = useState(false);
  const [loadind, setLoading] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setSeal({
      title: "",
      description: "",
      date_start: "",
      date_end: "",
      type: "",
      color: FIXED_FONT_COLOR_FLAG,
      background: FIXED_BACKGROUND_FLAG,
      status: "",
      file: "",
      csv: "",
      time_start: "",
      time_end: "",
    });
  };

  // Validação do formulário
  const validateSeal = (s) => {
    const e = {};

    // Campos obrigatórios para ambos os tipos
    if (!s.title || s.title.trim() === "")
      e.title = "Nome do selo é obrigatório.";
    if (!s.date_start) e.date_start = "Data inicial é obrigatória.";
    if (!s.date_end) e.date_end = "Data final é obrigatória.";
    if (s.date_start && s.date_end && s.date_start > s.date_end)
      e.date_end = "Data final deve ser igual ou posterior à data inicial.";
    if (!s.time_start) e.time_start = "Hora inicial é obrigatória.";
    if (!s.time_end) e.time_end = "Hora final é obrigatória.";
    if (s.time_start && s.time_end && s.time_start > s.time_end)
      e.time_end = "Hora final deve ser igual ou posterior à hora inicial.";

    // csv (campo presente no objeto do selo)
    if ((!s.csv && !isEdit) || (s.csv === "" && !isEdit))
      e.csv = "CSV é obrigatório.";

    // Validações específicas para flag
    if (s.type === "flag") {
      if (!s.description || s.description.trim() === "")
        e.description = "Descrição é obrigatória para flags.";
      if (!s.color || s.color === "")
        e.color = "Cor da fonte é obrigatória para flags.";
      if (!s.background || s.background === "")
        e.background = "Cor de fundo é obrigatória para flags.";
    }

    return { valid: Object.keys(e).length === 0, errors: e };
  };

  const canAddColor = seal.type === "flag" || seal.type === "frete";

  const handleSave = async () => {
    const { valid, errors: validationErrors } = validateSeal(seal);

    if (!valid) {
      setErrors(validationErrors);
      // opcional: levar o usuário ao topo do formulário para ver os erros
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    if (seal.title) {
      formData.append("title", seal.title);
    }

    if (seal.description) {
      formData.append("description", seal.description);
    }

    if (seal.date_start) {
      formData.append("date_start", `${seal.date_start} ${seal.time_start}:00`);
    }

    if (seal.date_end) {
      formData.append("date_end", `${seal.date_end} ${seal.time_end}:00`);
    }

    if (seal.type) {
      formData.append("type", seal.type);
    }

    if (seal.status) {
      formData.append("status", seal.status === "ativar" ? 1 : 0);
    }

    if (seal.type === "flag" || seal.type === "frete") {
      formData.append("color", FIXED_FONT_COLOR_FLAG);
      formData.append("background", FIXED_BACKGROUND_FLAG);
    }

    if (seal.image) {
      formData.append("file", seal.image);
    }

    if (seal.csv) {
      formData.append("csv", seal.csv);
    }

    setErrors({});

    if (isEdit) {
      await apiLabsV2.put(`/flags/${seal.id}`, formData);
      toast.success(`${seal.type} alterado com sucesso!`);
      window.location.reload();

      return;
    }

    await apiLabsV2.post("/flags", formData);
    window.location.reload();
    toast.success(`${seal.type} cadastrado com sucesso!`);
    handleCancel();
  };

  return (
    <>
      <Grid className={style.wrapperDetailsSeal}>
        <Typography variant="h2">Detalhes</Typography>

        <label htmlFor="name">
          <Typography variant="h5">Nome do selo</Typography>
          <TextField
            variant="outlined"
            type="text"
            id="name"
            placeholder="Insira aqui"
            value={seal.title}
            onChange={(e) => setSeal({ ...seal, title: e.target.value })}
            data-element="input"
            error={!!errors.title}
            helperText={errors.title || ""}
          />
        </label>

        <label htmlFor="type">
          <Typography variant="h5">Tipo do selo</Typography>
          <Select
            id="type"
            variant="outlined"
            placeholder="Selecione"
            value={seal.type}
            onChange={(e) => setSeal({ ...seal, type: e.target.value })}
            data-element="select"
            error={!!errors.type}
            helperText={errors.type || ""}
          >
            <MenuItem value="">Selecione</MenuItem>
            <MenuItem value="selo">Selo</MenuItem>
            <MenuItem value="flag">Flag</MenuItem>
            <MenuItem value="frete">Frete</MenuItem>
          </Select>
        </label>

        <label htmlFor="status">
          <Typography variant="h5">Status</Typography>
          <Select
            id="status"
            variant="outlined"
            placeholder="Selecione"
            value={seal.status}
            onChange={(e) => setSeal({ ...seal, status: e.target.value })}
            data-element="select"
            error={!!errors.type}
            helperText={errors.type || ""}
            classes={{
              selectMenu: style.teste,
            }}
          >
            <MenuItem value="">Selecione</MenuItem>
            <MenuItem value="ativar">Ativar</MenuItem>
            <MenuItem value="inativo">Inativo</MenuItem>
          </Select>
        </label>

        <label>
          <Typography variant="h5">Período de exibição do selo</Typography>

          <div data-element="period">
            <div>
              <span>De</span>
              <TextField
                type="date"
                variant="outlined"
                value={seal.date_start}
                onChange={(e) =>
                  setSeal({ ...seal, date_start: e.target.value })
                }
                data-element="date"
                error={!!errors.date_start}
                helperText={errors.date_start || ""}
              />
              <span>a</span>
              <TextField
                type="date"
                variant="outlined"
                value={seal.date_end}
                onChange={(e) => setSeal({ ...seal, date_end: e.target.value })}
                data-element="date"
                error={!!errors.date_end}
                helperText={errors.date_end || ""}
              />
            </div>

            <div>
              <span>Das</span>
              <TextField
                type="time"
                variant="outlined"
                value={seal.time_start}
                onChange={(e) =>
                  setSeal({ ...seal, time_start: e.target.value })
                }
                data-element="time"
                error={!!errors.time_start}
                helperText={errors.time_start || ""}
              />
              <span>Até</span>
              <TextField
                type="time"
                variant="outlined"
                location="ptBR"
                value={seal.time_end}
                onChange={(e) => setSeal({ ...seal, time_end: e.target.value })}
                data-element="time"
                error={!!errors.time_end}
                helperText={errors.time_end || ""}
              />
            </div>
          </div>
        </label>

        {canAddColor && seal.type === "flag" && (
          <div className={style.wrapperDetailsSeal}>
            <Typography variant="h2">Detalhes da lista tag</Typography>

            <label htmlFor="description">
              <Typography variant="h5">Descrição</Typography>
              <TextField
                variant="outlined"
                type="text"
                id="description"
                placeholder="Insira aqui"
                value={seal.description}
                onChange={(e) =>
                  setSeal({ ...seal, description: e.target.value })
                }
                data-element="input"
                error={!!errors.description}
                helperText={errors.description || ""}
              />
            </label>

            {/* {seal.type === "frete" && (
              <>
                <label htmlFor="background-color">
                  <Typography variant="h5">Cor da flag</Typography>
                  <TextField
                    variant="outlined"
                    type="color"
                    id="background-color"
                    placeholder="Insira aqui"
                    value={seal.background}
                    onChange={(e) =>
                      setSeal({ ...seal, background: e.target.value })
                    }
                    data-element="color"
                    error={!!errors.background}
                    helperText={errors.background || ""}
                  />
                </label>
                <label htmlFor="font-color">
                  <Typography variant="h5">Cor da fonte</Typography>
                  <TextField
                    variant="outlined"
                    type="color"
                    id="font-color"
                    placeholder="Insira aqui"
                    value={seal.color}
                    onChange={(e) =>
                      setSeal({ ...seal, color: e.target.value })
                    }
                    data-element="color"
                    error={!!errors.color}
                    helperText={errors.color || ""}
                  />
                </label>
              </>
            )} */}
          </div>
        )}

        <div className={style.sealPreview}>
          <Typography variant="h5">Preview</Typography>
          <Button variant="contained" onClick={handleClickOpen}>
            Clique aqui para visualizar
          </Button>
        </div>

        <div className={style.sealActions}>
          <Button
            variant="contained"
            data-element="cancel"
            onClick={handleCancel}
            isLoading={loadind}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            data-element="save"
            onClick={handleSave}
            isLoading={loadind}
          >
            Salvar
          </Button>
        </div>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={style.modalPreviewSeal}
      >
        <DialogContent>
          <Container spacing={2} className={style.previewSeal}>
            <Grid>
              <p data-element="title">Vitrine</p>
              <div data-element="shelf">
                <div data-element="shelf-foto">
                  {seal.image && (
                    <img
                      src={
                        typeof seal.image === "string"
                          ? seal.image
                          : URL.createObjectURL(seal.image)
                      }
                      alt="Selo"
                      width={30}
                      height={30}
                      style={{ position: "absolute", top: 10, left: 10 }}
                    />
                  )}
                  <img
                    src={FotoVitrine}
                    alt="Produto exemplo"
                    width={212}
                    height={180}
                  />
                </div>

                {seal.type === "flag" && (
                  <div
                    data-element="flag"
                    style={{ border: `1px solid ${FIXED_BACKGROUND_FLAG}` }}
                  >
                    <h3
                      style={{
                        background: `${FIXED_BACKGROUND_FLAG}`,
                        color: `${FIXED_FONT_COLOR_FLAG}`,
                      }}
                    >
                      {seal.title}
                    </h3>
                    <p>{seal.description}</p>
                  </div>
                )}

                {seal.type === "frete" && (
                  <div
                    data-element="frete"
                    style={{ border: `1px solid ${seal.background}` }}
                  >
                    <h3
                      style={{
                        background: `${seal.background}`,
                        color: `${seal.color}`,
                      }}
                    >
                      Title
                    </h3>
                  </div>
                )}
                <div data-element="shelf-content">
                  <img
                    src={Details}
                    alt="Detalhes do selo"
                    width={212}
                    height={270}
                  />
                </div>
              </div>
            </Grid>
            <Grid>
              <p data-element="title">Pagina de produto</p>
              <div data-element="product-page">
                <div data-element="bradcrumb">
                  <Typography>
                    <img src={Bradcrumb} alt="Home" width={24} height={24} />{" "}
                    {">"} Categoria {">"} Produto
                  </Typography>
                </div>
                <div data-element="product-page-content">
                  <img
                    src={Preview}
                    alt="Detalhes do selo"
                    width={90}
                    height={381}
                    data-element="preview"
                  />

                  <div data-element="product-page-foto">
                    {seal.image && (
                      <img
                        src={
                          typeof seal.image === "string"
                            ? seal.image
                            : URL.createObjectURL(seal.image)
                        }
                        alt="Selo"
                        width={30}
                        height={30}
                        style={{ position: "absolute", top: 10, left: 10 }}
                      />
                    )}
                    <img
                      src={FotoPDP}
                      alt="Foto do produto"
                      width={470}
                      height={380}
                      data-element="foto"
                    />
                  </div>
                  <div>
                    <img
                      src={Info}
                      alt="Informações do produto"
                      width={260}
                      height={125}
                    />
                    <img
                      src={Review}
                      alt="Avaliações do produto"
                      width={260}
                      height={19}
                    />
                    {seal.type === "flag" && (
                      <div
                        data-element="flag"
                        style={{ border: `1px solid ${FIXED_BACKGROUND_FLAG}` }}
                      >
                        <h3
                          style={{
                            background: `${FIXED_BACKGROUND_FLAG}`,
                            color: `${FIXED_FONT_COLOR_FLAG}`,
                          }}
                        >
                          Title
                        </h3>
                        <p>decrição</p>
                      </div>
                    )}

                    {seal.type === "frete" && (
                      <div
                        data-element="frete"
                        style={{ border: `1px solid ${seal.background}` }}
                      >
                        <h3
                          style={{
                            background: `${seal.background}`,
                            color: `${seal.color}`,
                          }}
                        >
                          Title
                        </h3>
                      </div>
                    )}
                    <img
                      src={Caracteristics}
                      alt="Características do produto"
                      width={260}
                      height={111}
                    />
                  </div>
                  <img
                    src={Cart}
                    alt="Carrinho e frete"
                    width={320}
                    height={169}
                  />
                </div>
              </div>
            </Grid>
          </Container>
        </DialogContent>
      </Dialog>
    </>
  );
};

DetailsSeal.propTypes = {
  seal: PropTypes.object.isRequired,
  setSeal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};
